// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2ZKU6Jt-EkeEQ0CQa7fiUr","day":"_12tm4Hw8LmQWq09EmjqMFf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/components/DayNames.mod.css
// module id = 1030
// module chunks = 0